'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Warning = function Warning(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M10.027 4.47c1.09-1.927 2.853-1.933 3.945 0l6.81 12.042c1.09 1.926.175 3.488-2.023 3.488H5.24c-2.206 0-3.115-1.556-2.022-3.488l6.809-12.043zm.87.491L4.089 17.004C3.373 18.268 3.798 19 5.24 19h13.52c1.435 0 1.864-.738 1.152-1.996L13.101 4.96c-.708-1.252-1.496-1.252-2.203 0zM11 8.991A.993.993 0 0 1 12 8a1 1 0 0 1 1 .99v4.02c0 .546-.444.99-1 .99a1 1 0 0 1-1-.99V8.99zM11 16c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Warning;